/* global G */
/* eslint-disable no-shadow,no-unused-vars */
import settings from '@tenant/settings'
import { back, detail, persistChange, persistCheck, persistOption, persistOptions, redirect } from 'app/_shared/events'
import { acl, cell, permission } from 'app/_shared/events/acl'
import component from 'app/_shared/events/acl/component'
import modelAttribute from 'app/_shared/events/acl/modelAttribute'
import action from 'app/_shared/events/action'
import { bulkByKey } from 'app/_shared/events/action/bulk'
import byKey from 'app/_shared/events/action/byKey'
import createRedirect from 'app/_shared/events/appbar/createRedirect'
import searchUnsortedAndRecreate from 'app/_shared/events/appbar/searchUnsortedAndRecreate'
import listGenericOptions from 'app/_shared/events/collection/listGenericOptions'
import listInvitationStatuses from 'app/_shared/events/collection/listInvitationStatuses'
import listOrganisationTypes from 'app/_shared/events/collection/listOrganisationTypes'
import listReducedUserRoles from 'app/_shared/events/collection/listReducedUserRoles'
import listRequestStatus from 'app/_shared/events/collection/listRequestStatus'
import listStatus from 'app/_shared/events/collection/listStatus'
import listStatusReasons from 'app/_shared/events/collection/listStatusReasons'
import listTicketFilterAssignee from 'app/_shared/events/collection/listTicketFilterAssignee'
import listTicketFilterCreated from 'app/_shared/events/collection/listTicketFilterCreated'
import listTicketFilterModified from 'app/_shared/events/collection/listTicketFilterModified'
import listTicketFilterStatus from 'app/_shared/events/collection/listTicketFilterStatus'
import listTicketFilterSubmitRole from 'app/_shared/events/collection/listTicketFilterSubmitRole'
import listTicketFilterTeam from 'app/_shared/events/collection/listTicketFilterTeam'
import listTicketStatus from 'app/_shared/events/collection/listTicketStatus'
import listTicketTypes from 'app/_shared/events/collection/listTicketTypes'
import listTimezones from 'app/_shared/events/collection/listTimezones'
import listUserRoles from 'app/_shared/events/collection/listUserRoles'
import persistChangeAndAction from 'app/_shared/events/combined/persistChangeAndAction'
import persistOptionsAndAction from 'app/_shared/events/combined/persistOptionsAndAction'
import persistStore, { persistItemStore, persistOptionsStore } from 'app/_shared/events/combined/persistStore'
import menu from 'app/_shared/events/contextmenu'
import link from 'app/_shared/events/link'
import itemLink from 'app/_shared/events/link/item'
import linkWithRef from 'app/_shared/events/link/withRef'
import { count, item, reference, user } from 'app/_shared/events/pubsub'
import conflict from 'app/_shared/events/pubsub/conflict'
import toAction from 'app/_shared/events/redirect/toAction'
import withRef from 'app/_shared/events/redirect/withRef'
import remember from 'app/_shared/events/remember'
import search from 'app/_shared/events/search'
import infinite from 'app/_shared/events/search/infinite'
import { personIsInvited } from 'app/_shared/events/search/query'
import userHasIdAndRoleAtOrg from 'app/_shared/events/search/query/userHasIdAndRoleAtOrg'
import searchWith from 'app/_shared/events/search/with'
import searchAndUpdateWithListKey from 'app/_shared/events/searchAndUpdateWithListKey'
import getUserRole from 'app/_shared/events/user/role'
import { sublist } from 'app/_shared/events/util'
import chain from 'app/_shared/events/util/chain'
import update from 'app/_shared/events/util/update'
import session from 'app/_shared/session'
import changeAtOrgs from 'app/admin/event/changeAtOrgs'
import checkNotification from 'app/admin/event/checkNotification'
import checkValidation from 'app/admin/event/checkValidation'
import deleteRoleInList from 'app/admin/event/deleteRoleInList'
import destroyIfNoSubItems from 'app/admin/event/destroyIfNoSubItems'
import getAtOrganisation from 'app/admin/event/getAtOrganisation'
import getDeletionStatus from 'app/admin/event/getDeletionStatus'
import getParentOrganisationAndAction from 'app/admin/event/getParentOrganisationAndAction'
import getSubLocationsOrParent from 'app/admin/event/getSubLocationsOrParent'
import impersonate from 'app/admin/event/impersonate'
import infiniteCandidates from 'app/admin/event/infiniteCandidates'
import linkToTargetDocument from 'app/admin/event/linkToTargetDocument'
import listDecoratedUserRoles from 'app/admin/event/listDecoratedUserRoles'
import listOrganisationsAndSort from 'app/admin/event/listOrganisationsAndSort'
import newPartialOption from 'app/admin/event/newPartialOption'
import organisationSubmitWith from 'app/admin/event/organisationSubmitWith'
import partialOption from 'app/admin/event/partialOption'
import partialOptionDelete from 'app/admin/event/partialOptionDelete'
import persistOptionsOrGeneric from 'app/admin/event/persistOptionsOrGeneric'
import redirectToApproveAsOriginalOrDuplicate from 'app/admin/event/redirectToApproveAsOriginalOrDuplicate'
import isCandidate from 'app/admin/event/search/isCandidate'
import searchOrganisationMulti from 'app/admin/event/searchOrganisationMulti'
import sendPasswordRecovery from 'app/admin/event/sendPasswordRecovery'
import setAtOrgInList from 'app/admin/event/setAtOrgInList'
import setAtOrgSelection from 'app/admin/event/setAtOrgSelection'
import setRoleInList from 'app/admin/event/setRoleInList'
import setUserOrganisationIfNotSet from 'app/admin/event/setUserOrganisationIfNotSet'
import swapOrganisationAndAction from 'app/admin/event/swapOrganisationAndAction'
import toggleEmailValidation from 'app/admin/event/toggleEmailValidation'
import validateNote from 'app/admin/event/validateNote'
import infinitePersonsWithUsers from 'app/person/event/infinitePersonsWithUsers'
import updateRequestList from 'app/request/event/updateRequestList'
import listingByStatus from 'app/ticket/event/list/byStatus'
import searchAllOrMyTeams from 'app/ticket/event/searchAllOrMyTeams'
import updateTicketList from 'app/ticket/event/updateTicketList'
import updateUnreadMessagesCount from 'app/ticket/event/updateUnreadMessagesCount'
import asObject from 'lib/sequence/component/children/asObject'
import sequenceComponentFindProxy from 'lib/sequence/component/children/find'
import { get, reset } from 'lib/sequence/component/state/value'
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'
import { curry, getFirstItem, setKey } from 'lib/util'
import routeComposition from 'trait/composition/route'

export default {
  acl: {
    acl,
    cell,
    modelOrganisation: modelAttribute('organisation'),
    component,
    permission,
  },
  onSearch: {
    searchUnsortedAndRecreate,
    searchAndUpdateWithDuplicateOf: searchAndUpdateWithListKey('duplicateOf'),
  },
  onCreate: {
    createRedirect,
  },
  onOpen: {
    // search
    search: search(null),
    searchVerbose: search('verbose'),
    searchOrganisationMulti,
    getSubLocationsOrParent,
    searchWithFilter: chain(
      searchWith(['filter']),
      search(null),
    ),
    searchVerboseWithFilter: chain(
      searchWith(['filter']),
      search('verbose'),
    ),
    searchValidatedWithFilter: chain(
      searchWith(['filter']),
      curry(async (module, component, event) => {
        const result = await search('default', module, component, event)
        return result.filter(x => !x?.value?.toBeValidated)
      }),
    ),
    searchAllOrMyTeams,
    // infinite
    infinite: infinite(null),
    infiniteVerbose: infinite('verbose'),
    infiniteUsers: curry(async (module, component, event) => {
      const result = await infinite('default', module, component, event)
      const data = result.data.map(row => ({ ...row, value: { ...row.value, loginName: row.key } }))

      return { ...result, data }
    }),
    infinitePersonsWithQuery: chain(
      searchWith(['query']),
      infinitePersonsWithUsers,
    ),
    infiniteCandidates,
    // listing
    listingByStatus: listingByStatus('short'),
    listReducedUserRoles,
    listOrganisationsWithFilter: chain(
      searchWith(['filter']),
      listOrganisationsAndSort,
    ),
    listTicketTypes: curry((module, component, event) => listTicketTypes(module, component, event)
      .filter(type => !type.hidden)),
    listDecoratedUserRolesAndSetData: curry(async (module, component, event) => {
      const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
      const { rolesList } = sequenceComponentFindProxy(actionComponent)

      const roles = await listDecoratedUserRoles(module, component, event)
      setKey(roles, 'data', rolesList[G.STATE])

      return roles
    }),
    listUserRoles,
    listRoles: listUserRoles,
    listTeamDefaultRoles: sublist(settings.teamDefaultRoles, listUserRoles, false),
    listTimezones,
    listStatus,
    link,
    linkToPerson: linkWithRef('person'),
    linkToTargetDocument,
    item: itemLink,
    reference, // edit form
  },
  onShowAll: {
    infinite: infinite('verbose'),
  },
  onGroup: {
    isNotCurrentOrg: curry((module, component, event) => {
      const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
      const { organisation } = sequenceComponentFindProxy(actionComponent)
      const currentOrganisation = getFirstItem(get(organisation))
      const { option } = event?.detail || event || {}

      return !currentOrganisation
        ? false
        : option?.key !== currentOrganisation?.key
    }),
    isNotNone: curry((module, component, event) => {
      const { option } = event?.detail || event || {}
      return option?.key !== 'none'
    }),
  },
  onRoleOpen: {
    listUserRoles,
  },
  onAtOrgOpen: {
    listOrganisationsWithFilter: chain(
      searchWith(['filter']),
      curry(async (module, component, event) => await search(
        null, module, component, { ...event?.detail?.term && { term: event.detail.term } },
      )),
    ),
  },
  onAtOrgCreate: {
    getAtOrganisation,
  },
  onRoleChange: {
    persistRole: chain(
      partialOption('roles', 'role'), // This is for updating the data eventually sent to server
      setRoleInList, // this is for updating data in the list to reflect in the UI
    ),
  },
  onAtOrgChange: {
    persistAtOrg: chain(
      partialOption('roles', 'atOrg'), // This is for updating the data eventually sent to server
      setAtOrgInList, // this is for updating data in the list to reflect in the UI
    ),
  },
  onRoleDelete: {
    deleteRole: chain(
      partialOptionDelete('roles'), // This is for updating the data eventually sent to server
      deleteRoleInList, // this is for updating data in the list to reflect in the UI
    ),
  },
  onRoleCreate: {
    getDeletionStatus,
  },
  onRoleDeleteOpen: {
    getDeletionStatus,
  },
  onClick: {
    back,
    detail,
    detailWithPerson: withRef(detail, 'person'),
    redirect,
    redirectWithPerson: curry(async (module, component, event) => {
      const { detail: { item: person } } = event
      const moduleState = module[G.STATE]
      const { route } = component[G.CONFIGURATION]
      moduleState[G.ROUTE] = routeComposition(route.module, route.action)
      await redirectSequence(module)(person)
    }),
    impersonate,
    userBulk: bulkByKey('userBulk'),
    teamEdit: toAction('teamEdit'),
    teamSubmit: byKey('teamSubmit'),
    organisationSubmit: byKey('organisationSubmit'),
    originalSubmit: byKey('originalSubmit'),
    duplicateSubmit: byKey('duplicateSubmit'),
    blockSubmit: byKey('blockSubmit'),
    deleteSubmit: byKey('deleteSubmit'),
    sendPasswordRecovery,
    swapOrganisationAndAction,
    destroyIfNoSubItems,
    organisationSubmitWith: organisationSubmitWith('submit'),
    revertCheckDuplicate: organisationSubmitWith('revert'),
    redirectToApproveAsOriginalOrDuplicate,
    getParentOrganisationAndAction,
  },
  onChange: {
    persistCheck,
    persistStore,
    persistChange,
    toLowerCaseAndPersistChange: curry((module, component, event) => {
      persistChange(
        module,
        component,
        { ...event, detail: { value: event.detail.value.toLowerCase() } },
      )
    }),
    persistChangeAndAction,
    persistChangeAndCheckValidation: chain(
      persistChange,
      checkValidation,
    ),
    persistChangeAndValidateNote: chain(
      persistChange,
      validateNote,
    ),
    persistCheckAndToggleEmail: chain(
      persistCheck,
      toggleEmailValidation,
    ),
    persistChangeAndCheckNotificationAndToggleEmail: chain(
      persistChange,
      checkNotification,
      toggleEmailValidation,
    ),
    persistOption,
    persistOptions,
    persistOptionsStore,
    persistOptionsAndAction,
    persistOptionsOrGeneric,
    persistOptionsAndCheckValidation: chain(
      persistOptions,
      checkValidation,
    ),
    changeAtOrgsAndPersistOptions: chain(
      setAtOrgSelection,
      changeAtOrgs,
      persistOptions,
      update,
    ),
    persistNewRole: newPartialOption('roles', 'role'),
    persistNewAtOrg: chain(
      setUserOrganisationIfNotSet,
      newPartialOption('roles', 'atOrg'),
    ),
    persistOptionsRememberAndAction: chain(
      persistOptions,
      remember,
      action,
    ),
    persistCheckRememberAndAction: chain(
      persistCheck,
      remember,
      action,
    ),
    persistChangeRememberAndAction: chain(
      persistChange,
      remember,
      action,
    ),
    persistItemStore,
    changeTeamList: curry(async (module, component, event) => {
      const { filter } = asObject(module[G.STATE][G.ACTION][G.COMPONENT][G.CHILDREN])
      const { assignee } = asObject(filter[G.CHILDREN])
      reset(assignee)
      await persistOptions(module, component, event)
      await remember(module, component, event)
      await action(module, component, event)
    }),
    selectRememberAndAction: chain(
      persistOptions,
      remember,
      action,
    ),
  },
  onClose: {
    back,
  },
  onAction: {
    organisationSubmitWith: organisationSubmitWith('submit'),
  },
  onContextMenu: {
    menu: menu(null),
  },
  onPage: {
    remember,
  },
  onPublication: {
    conflict,
    updateTicketList,
    updateRequestList,
  },
  onLinkChange: {
    setLink: link,
  },
  getTicketType: {
    listTicketTypes,
  },
  getOrganisationType: {
    listOrganisationTypes,
  },
  getStatus: {
    listStatus,
    listTicketStatus,
    listRequestStatus,
    listInvitationStatuses,
  },
  getStatusReason: {
    listStatusReasons,
  },
  getSelection: {
    listGenericOptions,
    listTicketFilterStatus,
    listTicketFilterTeam,
    listTicketFilterAssignee,
    listTicketFilterCreated,
   listTicketFilterModified,
    listTicketFilterSubmitRole,
    getCurrentOrganisation: curry((module, component, event) => {
      const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
      const { organisation } = sequenceComponentFindProxy(actionComponent)
      const currentOrganisation = get(organisation)

      return currentOrganisation || []
    }),
  },
  getRole: {
    getUserRole: curry((module, component, roles) => getUserRole(roles, module, component, null)),
  },
  getLabel: {
    listUserRoles,
    listOrganisationTypes,
  },
  count: {
    sub: count,
  },
  item: {
    sub: item,
    user,
  },
  list: {
    // sub: filteredOption('team'),
    sub: reference,
    user,
  },
  cell: {
    sub: updateUnreadMessagesCount,
  },
  filter: {
    isNotInactive: curry((module, component, event) => ({
      status: { max: 79 },
    })),
    isActive: curry((module, component, event) => ({
      status: { max: 79 },
    })),
    isActiveAndNotMyself: curry((module, component, event) => ({
      status: 50,
      id: `!${session(module).person.key()}`,
    })),
    isActiveAndNotInternalAndNotThisOrganisation: curry((module, component, event) => ({
      status: 50,
      id: `!${module[G.MODEL][G.CHILDREN].organisation?.[G.STATE]?.[G.REF]}`,
      type: '!internal',
    })),
    hasPersonRef: curry((module, component, event) => ({
      refexists: 'person',
    })),
  },
  query: {
    userHasIdAndRoleAtOrg,
    personIsInvited,
    isCandidate,
  },
}
